module.exports = __webpack_public_path__ + "static/media/our-values-img.f9997a65.png";